module.exports = __webpack_public_path__ + "static/media/wizualizacja-22.0a94041c.png";